import React from 'react'
// import Link
import { Link } from 'react-router-dom'
// import Icon
import Map from "../../assets/img/icon/sm-location.png"
import Mail from "../../assets/img/icon/email-color.png"
import Phone from "../../assets/img/icon/phon-color.png"



const ContactArea = () => {
return (
    <>

             <section id="contact_arae_main" className="section_padding">
            <div className="container">
                    <div className="row">
                            {/* <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                                    <div className="section_heading">
                                            <h3>Contact Us</h3>
                                            <h2>Get In
                                                    <span className="color_bi11g_heading"> Touch</span> With Us 
                                            </h2>
                                    </div>
                            </div> */}

                                <div className="col-12 text-center mb-5">
                        <div className="section_title">
                            <p className="section_subtitle">Contact</p>
                            <h2 className="section_heading">Contact Us</h2>
                        </div>
                    </div>
                    </div>
                    <div className="row">
                            <div className="col-lg-12">
                                    <div className="contact_area_left">
                                            <div className="contact_left_item">
                                                    <div className="contact_left_icon">
                                                            <img src={Map} alt="icon" />
                                                    </div>
                                                    <div className="contact_left_text">
                                                            <h3>Address:</h3>
                                                            <p> 6 Amamieson Aimiuwa Lane, Uselu, Benin City, <br />   Edo State, Nigeria</p>
                                                    </div>
                                            </div>
                                            <div className="contact_left_item">
                                                    <div className="contact_left_icon">
                                                            <img src={Mail} alt="icon" />
                                                    </div>
                                                    <div className="contact_left_text">
                                                            <h3>Email:</h3>
                                                            <Link to="mailto:her@cradlecarefoundation.org">her@cradlecarefoundation.org</Link>
                                                            {/* <Link to="mailto:support@domain.com">Contact@domain.com</Link> */}
                                                    </div>
                                            </div>
                                            <div className="contact_left_item">
                                                    <div className="contact_left_icon">
                                                            <img src={Phone} alt="icon" />
                                                    </div>
                                                    <div className="contact_left_text">
                                                            <h3>Phone Number:</h3>
                                                            <Link to="tel:+234 813 548 1763">+234 813 548 1763</Link>
                                                            {/* <Link to="tel:+01-123-456-789">+02 345 678 901</Link> */}
                                                    </div>
                                            </div>
                                    </div>
                            </div>
                            {/* <div className="col-lg-6">
                                    <div className="contact_form_Wrapper">
                                            <h3>Leave Us A Message</h3>
                                            <form action="#!" id="contact_form">
                                                    <div className="form-group">
                                                            <input type="text" className="form-control" placeholder="Your Full Name*" required />
                                                    </div>
                                                    <div className="form-group">
                                                            <input type="email" className="form-control" placeholder="Your Email Address*" required />
                                                    </div>
                                                    <div className="form-group">
                                                            <input type="text" className="form-control" placeholder="Subject**" required />
                                                    </div>
                                                    <div className="form-group">
                                                            <textarea className="form-control" rows="6" placeholder="Message*" required></textarea>
                                                    </div>
                                                    <div className="contact_submit_form">
                                                            <button className="btn btn_theme btn_md">Send Message</button>
                                                    </div>
                                            </form>
                                    </div>
                            </div> */}
                    </div>
            </div>
    </section>
             {/* <section id="contact_arae_main" className="section_padding">
            <div className="container">
                    <div className="row">
                            <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                                    <div className="section_heading">
                                            <h3>Contact With Us</h3>
                                            <h2>Get In
                                                    <span className="color_big_heading">Touch</span>With Us &
                                                    Stay Updates
                                            </h2>
                                    </div>
                            </div>
                    </div>
                    <div className="row">
                            <div className="col-lg-6">
                                    <div className="contact_area_left">
                                            <div className="contact_left_item">
                                                    <div className="contact_left_icon">
                                                            <img src={Map} alt="icon" />
                                                    </div>
                                                    <div className="contact_left_text">
                                                            <h3>Address:</h3>
                                                            <p>107, Broklyn Golden Road Street. New York, <br /> United States Of America</p>
                                                    </div>
                                            </div>
                                            <div className="contact_left_item">
                                                    <div className="contact_left_icon">
                                                            <img src={Mail} alt="icon" />
                                                    </div>
                                                    <div className="contact_left_text">
                                                            <h3>Email:</h3>
                                                            <Link to="mailto:support@domain.com">Support@domain.com</Link>
                                                            <Link to="mailto:support@domain.com">Contact@domain.com</Link>
                                                    </div>
                                            </div>
                                            <div className="contact_left_item">
                                                    <div className="contact_left_icon">
                                                            <img src={Phone} alt="icon" />
                                                    </div>
                                                    <div className="contact_left_text">
                                                            <h3>Phone Number:</h3>
                                                            <Link to="tel:+01-123-456-789">+01 123 456 789</Link>
                                                            <Link to="tel:+01-123-456-789">+02 345 678 901</Link>
                                                    </div>
                                            </div>
                                    </div>
                            </div>
                            <div className="col-lg-6">
                                    <div className="contact_form_Wrapper">
                                            <h3>Leave Us A Message</h3>
                                            <form action="#!" id="contact_form">
                                                    <div className="form-group">
                                                            <input type="text" className="form-control" placeholder="Your Full Name*" required />
                                                    </div>
                                                    <div className="form-group">
                                                            <input type="email" className="form-control" placeholder="Your Email Address*" required />
                                                    </div>
                                                    <div className="form-group">
                                                            <input type="text" className="form-control" placeholder="Subject**" required />
                                                    </div>
                                                    <div className="form-group">
                                                            <textarea className="form-control" rows="6" placeholder="Message*" required></textarea>
                                                    </div>
                                                    <div className="contact_submit_form">
                                                            <button className="btn btn_theme btn_md">Send Message</button>
                                                    </div>
                                            </form>
                                    </div>
                            </div>
                    </div>
            </div>
    </section> */}
    </>
)
}

export default ContactArea